import { getCurrentCurrencySymbol } from "./utils";

interface PrettifyNumbersOptions {
  showCurrencySymbol?: boolean;
}

const currencySymbol = getCurrentCurrencySymbol();

export const prettifyNumbers = (value: number, { showCurrencySymbol = false }: PrettifyNumbersOptions = {}): string => {
  // Переводим в строку, чтобы JS ничего не округлял при парсинге
  const [integerPart, fractionalPart] = value.toString().split(".");

  // Красиво форматируем только целую часть
  const formattedIntegerPart = Number(integerPart).toLocaleString("ru-RU");

  // Берем только 2 первых знака после запятой
  const formattedFractionalPart = fractionalPart ? fractionalPart.slice(0, 2) : "00";

  let result = fractionalPart ? `${formattedIntegerPart},${formattedFractionalPart}` : integerPart;

  if (showCurrencySymbol) {
    result = `${result} ${currencySymbol}`;
  }

  // Если есть дробная часть, приклеиваем её через запятую и пробел
  return result;
};
